import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Container, Row, Col } from 'react-bootstrap';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean;
  requireGuest?: boolean;
}

export default function ProtectedRoute({ 
  children, 
  requireAuth = true, 
  requireGuest = false 
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading spinner while auth state is being determined
  if (isLoading) {
    return (
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col md={6} className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Loading...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  // Redirect to login if authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    return (
      <Navigate 
        to={`/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`} 
        replace 
      />
    );
  }

  // Redirect to home if guest access is required but user is authenticated
  if (requireGuest && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
